import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  getImageUrl,
  getImageVariant,
} from '../../../../utility/util/util.service';
import { AvForm } from 'availity-reactstrap-validation';
import ImageDropzoneComponent from '../../form/dropzones/image-dropzone/image-dropzone.component';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import { connect } from 'react-redux';
import { closeModalSafely, handleSubmit } from './edit-store-logo.service';
import PropTypes from 'prop-types';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { fetchStore } from '../../../../redux/store/store.actions';
import {
  execOnSuccess,
  setIsEditStoreLogoModalOpen,
} from '../../../../redux/modal/modal.actions';
import DefaultAlertComponent from '../../alerts/default-alert/default-alert.component';

const EditStoreLogo = ({
  isOpen,
  onSuccess,
  store,
  intl,
  fetchStore,
  setIsEditStoreLogoModalOpen,
}) => {
  const [uploadImage, setUploadImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (isOpen && store?.menu) {
      setUploadImage(null);
      const variant = getImageVariant('storeLogo');
      setPreviewUrl(getImageUrl(store.logo, variant) || null);
    } else {
      // reset modal on closing
      setUploadImage(null);
      setPreviewUrl(null);
    }
  }, [isOpen, store]);

  const closeModal = () => setIsEditStoreLogoModalOpen(false);
  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) =>
    handleSubmit(
      event,
      errors,
      values,
      uploadImage,
      { id: store?.id }, // id is needed for patch
      setIsSubmitting,
      closeModal,
      () => fetchStore(null, true, false, () => execOnSuccess(onSuccess)),
    );

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({ id: 'editStoreLogoTitle' })}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            className="m-auto"
            isSubmitting={isSubmitting}
            disabled={isSubmitting}
            onClick={() => formRef?.current.handleSubmit()}
          />
        </div>
      }
    >
      <div className="px-1">
        <DefaultAlertComponent
          msg={intl.formatMessage({ id: 'editStoreLogoText' })}
        />
        <AvForm ref={formRef} onSubmit={_handleSubmit} disabled={isSubmitting}>
          <div className="mt-2">
            <ImageDropzoneComponent
              propertyName="coverImage"
              object={{}}
              setter={() => undefined}
              previewUrl={previewUrl}
              setPreviewUrl={setPreviewUrl}
              setUploadImage={setUploadImage}
              isDisabled={isSubmitting}
            />
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

EditStoreLogo.propTypes = {
  isOpen: PropTypes.bool,
  onSuccess: PropTypes.func,
  intl: PropTypes.object,
  store: PropTypes.object,
  isEditStoreLogoModalOpen: PropTypes.func,
  fetchStore: PropTypes.func,
  setIsEditStoreLogoModalOpen: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isEditStoreLogoModalOpen,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  fetchStore,
  setIsEditStoreLogoModalOpen,
})(injectIntl(EditStoreLogo));
